import { z } from "zod";

/**
 * `onlyMine` — „nur meine Kunden" als **Wahl**, nicht als Folge der Rolle.
 *
 * Bis zum 2026-09-10 leitete `getVisibleCustomerIds` die Menge aus der Rolle
 * ab, als Kaskade: Admin/GL alles, Bereichsleitung ihr Segment, Projektleiter
 * ihre Lead-Kunden — der erste Treffer gewinnt. Wer Bereichsleiter UND Lead
 * ist, sah damit immer den ganzen Bereich und nie „nur meine".
 *
 * `onlyMine=true` schneidet auf die **Zellen** (Kunde × Segment), in denen
 * der Nutzer Service Lead ist — nicht auf Kunden: Termine und Wartung leben
 * auf Zellen, und ein Kunde, bei dem man in HR Lead ist, hat in Prolo einen
 * anderen (2026-09-11). `false` oder weggelassen: die bisherige Kaskade.
 *
 * Der Name folgt der BCG-Matrix (`?onlyMine=`), damit die URL-Parameter der
 * Anwendung eine Sprache sprechen. Über die URL kommt ein String an, aus dem
 * Frontend-Code ein Boolean — das Schema nimmt beides; `z.coerce.boolean`
 * schied aus, weil es aus `"false"` `true` macht.
 */
export const onlyMineQuerySchema = z
  .union([z.boolean(), z.enum(["true", "false"]).transform((v) => v === "true")])
  .optional();
